<template>
  <w-settings-content-template side-title="가상화 센터">
    <w-virtual-center-tree slot="sideContent" ref="sideTree" @clickNode="onClickNode"/>
    <div slot="content">
      <w-virtual-center-table v-show="!isLeaf" :selected-node="selectedNode" :is-leaf="isLeaf"/>
      <w-host-ip-range-table v-show="isLeaf" :selected-node="selectedNode" :is-leaf="isLeaf"/>
    </div>
  </w-settings-content-template>
</template>
<script>
import isNil from 'lodash/isNil';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WVirtualCenterTree from './components/VirtualCenterTree';
import WVirtualCenterTable from './components/VirtualCenterTable';
import WHostIpRangeTable from './components/HostIpRangeTable';

export default {
  name: 'WIpRangeSetting',
  components: {
    WVirtualCenterTree,
    WSettingsContentTemplate,
    WVirtualCenterTable,
    WHostIpRangeTable,
  },
  data() {
    return {
      selectedNode: null,
    };
  },
  computed: {
    isLeaf() {
      const selectedNode = this.selectedNode;
      return !isNil(selectedNode) && selectedNode.leaf;
    },
  },
  methods: {
    onClickNode(data) {
      this.selectedNode = data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/virtual/Provisioning/IpRangeSetting/index.vue